
import { Component, Vue } from "vue-property-decorator";

@Component
export default class AboutTygy extends Vue {
  render() {
    return (
      <div class="about-page">
        <div class="banner">
          <div class="banner-declaration">
            <div class="dec-m">我们坚持永不停息的奋斗精神</div>
            <div class="dec-l">与时俱进 开拓创新</div>
          </div>
        </div>
        {/**我们能做什么 */}
        <div style="height:70px;"></div>
        <div class="inner-content">
          <div class="do-what">
            <div class="left-content">
              <div class="tip">我们能做什么</div>
              <div class="slogan">雷拓尔菲公寓</div>
              <div class="slogan">以“成就客户”为服务理念</div>
              <div style="height:20px;"></div>
              <div class="divide"></div>
              <div style="height:10px;"></div>
              <p class="content">
                北京雷拓尔菲科技有限公司（简称：雷拓尔菲公寓）成立于2010年，经过十余载不懈的努力，打造了一支具有活力和进取精神的队伍，企业竞争力不断的增强，企业发展空间不断拓展，从而快速平稳入良性循环发展轨道。截止目前，公司从业人员越百人，公司法人治理架构健全，公司迅速成长扩大，近几年：郑州，北京，上海等多个一线城市覆盖业务。
                <br />
                雷拓尔菲公寓在不断发展壮大的同时，始终本着专业.诚信.优质服务的宗旨，以“成就客户”为服务理念，始终为客户争取最大利益出发。不断拓展业务的广度和深度，系统化的解决方案，为客户提供最完美的服务。
              </p>
              <div style="height:20px;"></div>
            </div>
            <div class="right-content"></div>
          </div>
        </div>
        <div style="height:100px;"></div>
        <div class="ty-culture">
          <div class="inner-content">
            <div style="height:20px;"></div>
            <div class="title">雷拓尔菲文化</div>
            <div style="height:40px;"></div>
            <div class="content">
              <div>
                <div>
                  <img src={require("@/assets/形状.png")} />
                </div>
                <div>企业宗旨</div>
                <div>为客户创造价值</div>
                <div>为企业创造利益</div>
                <div>为员工创造财富</div>
                <div>为社会创造繁荣</div>
              </div>
              <div class="divide"></div>
              <div>
                <div>
                  <img src={require("@/assets/形状(1).png")} />
                </div>
                <div>企业精神</div>
                <div>艰苦奋斗</div>
                <div>开拓创新</div>
                <div>诚实做人</div>
                <div>踏实做事</div>
              </div>
              <div class="divide"></div>
              <div>
                <div>
                  <img src={require("@/assets/形状(2).png")} />
                </div>
                <div>经营理念</div>
                <div>规范管理</div>
                <div>恪守诚信</div>
                <div>追求卓越</div>
                <div>务实创新</div>
              </div>
            </div>
            <div style="height:20px;"></div>
          </div>
        </div>
        <div class="inner-content">
          <div class="dev-history">
            <div style="height:40px;"></div>
            <div class="title">发展历程</div>
            <div class="content">
              <div class="left-content"></div>
              <div class="right-content">
                <a-timeline mode="right">
                  <a-timeline-item color="#D2D3D4">
                    <span class="title">公司成立</span>
                    <span class="time">2010-01-01</span>
                    <div class="content-time">
                      北京雷拓尔菲科技有限公司成立于2010年，经过十余载不懈的努力
                    </div>
                  </a-timeline-item>
                  <a-timeline-item color="#D2D3D4">
                    <span class="title">公司成立</span>
                    <span class="time">2010-01-01</span>
                    <div class="content-time">
                      北京雷拓尔菲科技有限公司成立于2010年，经过十余载不懈的努力
                    </div>
                  </a-timeline-item>
                  <a-timeline-item color="#D2D3D4">
                    <span class="title">公司成立</span>
                    <span class="time">2010-01-01</span>
                    <div class="content-time">
                      北京雷拓尔菲科技有限公司成立于2010年，经过十余载不懈的努力
                    </div>
                  </a-timeline-item>
                  <a-timeline-item color="#D2D3D4">
                    <span class="title">公司成立</span>
                    <span class="time">2010-01-01</span>
                    <div class="content-time">
                      北京雷拓尔菲科技有限公司成立于2010年，经过十余载不懈的努力
                    </div>
                  </a-timeline-item>
                </a-timeline>
              </div>
            </div>
          </div>
          <div style="height:80px;"></div>
          <div class="team">
            <div class="title">团队风采</div>
            <div style="height:20px;"></div>
            <div class="team-img">
              <div class="team-l">
                <img src={require("@/assets/d.jpg")} />
              </div>
              <div class="team-c">
                <img src={require("@/assets/pexels-photo-886465.jpg")} />
                <img src={require("@/assets/pexels-photo-1024311.jpg")} />
                <img src={require("@/assets/501373001_4_0.jpg")} />
              </div>
              <div class="team-r">
                <img src={require("@/assets/timg.jpeg")} />
                <img src={require("@/assets/pexels-photo-1647905.jpg")} />
              </div>
            </div>
          </div>
        </div>
        <div style="height:50px;"></div>
      </div>
    );
  }
}
